import { useTranslation } from "react-i18next";
import AnimatedComponent from "../../components/atom/AnimatedComponent";
import EllipsisText from "../../components/atom/EllipsisText";
import HeaderAbout from "../../components/atom/HeaderAbout";
import HeaderTitle from "../../components/atom/HeaderTitle";
import { useAuth } from "../../context/DataContext";
import { FLAG_MAP, JURIST_LIST } from "../../constant/datas/JuristData";

const NotableJurist = () => {

    const { isMobileAndSmaller } = useAuth();

    const { t } = useTranslation();

    const juristList = JURIST_LIST(t);

    return (
        <div style={{ background: "black", paddingTop: 70 }} >
            <div className="container" >
                <HeaderTitle>
                    <HeaderAbout title={"JURISTS"} />
                </HeaderTitle>

                <div className="text-align-justify align-items-start row" style={{ color: "white" }}>
                    {juristList.map((eachData, index) => {
                        const colClass = "col-6 col-md-4";

                        return (
                            <div key={`jurist-${index}`} className={colClass} style={{ marginBottom: 60 }}>
                                <div className="jurist-image-container">
                                    <AnimatedComponent animationClass="animate__fadeIn">
                                        <img loading="lazy" src={eachData.image} alt={eachData.name} className="jurist-image" />
                                    </AnimatedComponent>
                                </div>
                                <div className="mangolaineFont text-align-center" style={{ fontSize: isMobileAndSmaller ? "6vmin" : "3.5vmin", marginBottom: 20 }}>
                                    {eachData.name.toUpperCase()}
                                </div>
                                <div style={{ marginBottom: 20 }}>
                                    {eachData.title}
                                </div>
                                <div className="d-flex" style={{ marginBottom: 40 }}>
                                    {eachData.country.map((eachCountry, countryIndex) => (
                                        <img 
                                            key={`country-${index}-${countryIndex}`} 
                                            src={FLAG_MAP[eachCountry]} 
                                            alt={eachCountry} 
                                            style={{ height: 26, marginRight: 13, width: isMobileAndSmaller ? 35 : 50 }} 
                                        />
                                    ))}
                                </div>
                                <div>
                                    <EllipsisText quote={eachData.quote} link={eachData.link} />
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div >
    )
}
export default NotableJurist